import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact } from "higher-order-components"
import { StatList, GalleryItem, GalleryGrid } from "containers"
import { Section, H4, Space } from 'AtomicComponents'
import { renderComponent } from "containers/utilities"

/** Render a full width image section */
class Gallery extends React.PureComponent {
  static propTypes = {
    compact: PropTypes.bool,
    heading: PropTypes.string,
    galleryItems: PropTypes.array.isRequired,
    description: PropTypes.string,
    layoutsItems: PropTypes.array,
    statList: PropTypes.array
  }

  constructor(props) {
    super(props)

    this.state = {
      hoverIndex: -1
    }
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index
    })
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: -1
    })
  }

  /**
   * @param {String} heading - Heading text.
   * @param {Array|statList} [statList] - List of stats for StatList.
   * @param {Array|GalleryGrid} [galleryItems] - roundIconButton component props.
   * @returns {ReactElement} React Component
   */
  render() {
    const {
      description, statList, heading, galleryItems, layoutsItems, compact
    } = this.props
    const { hoverIndex } = this.state

    return (
      <Section padding>
        <div style={{ width: "100%", overflow: "hidden" }}>
          <H4 withDetails>{heading}</H4>
          <Space />
          {description && <p style={styles.description}>{description}</p>}
          {false && (
            <div style={{ margin: "1em 0" }}>
              <StatList stats={statList} />
            </div>
          )}
          <GalleryGrid layouts={layoutsItems}>
            {galleryItems.map((item, index) =>
              (item.name === "GalleryItem" ? (
                <GalleryItem
                  key={index}
                  {...item.props}
                  active={hoverIndex === index}
                  fade={hoverIndex !== -1 && hoverIndex !== index}
                  compact={compact}
                  slideShowItems={galleryItems.map(item => ({
                    name: "SlideshowItem",
                    props: {
                      imageSrc: item.props.imageSrc,
                      heading: item.props.title,
                      blurb: item.props.blurb
                    }
                  }))}
                  index={index}
                  handleMouseEnter={this.handleMouseEnter.bind(this, index)}
                  handleMouseLeave={this.handleMouseLeave.bind(this, index)} />
              ) : (
                renderComponent(item)
              )))}
          </GalleryGrid>
        </div>
      </Section>
    )
  }
}

export default withRadium(DetectCompact())(Gallery)

const styles = {
  description: {
    fontWeight: "200",
    fontSize: "100%",
    lineHeight: "1.6",
    margin: "1.5em 0",
    letterSpacing: "0.01em"
  }
}



// WEBPACK FOOTER //
// ./src/containers/gallery/index.jsx